import {
  AreaChart,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine,
  Tooltip,
} from "recharts";
import { BarChart3 } from "lucide-react";
import "./MonthlyTrends.scss";

const MonthlyTrends = ({ dashboardData }) => {
  const last5Months = dashboardData?.last5Months || [];

  const chartData = last5Months.map((item, index) => ({
    name: item.name ?? String(index + 1),
    value: item.value ?? 0,
  }));

  const latestValue =
    last5Months.length > 0
      ? (last5Months[last5Months.length - 1]?.value ?? 0)
      : 0;

  return (
    <div className="chart-container monthly-trends">
      <div className="monthly-trends__header">
        <BarChart3 className="monthly-trends__icon" size={22} />
        <h3 className="chart-title">Monthly Trends</h3>
      </div>

      <div className="monthly-trends__content">
        <div className="monthly-trends__stats">
          <span className="monthly-trends__value">{latestValue}</span>
          <span className="monthly-trends__label">This Month</span>
        </div>

        <div className="monthly-trends__chart">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={chartData}
              margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient id="trendGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#133F7D" stopOpacity={1} />
                  <stop offset="100%" stopColor="#12B6BC" stopOpacity={0.1} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" hide />
              <YAxis hide domain={[0, "auto"]} />
              <CartesianGrid
                strokeDasharray="4 4"
                vertical={false}
                horizontal={false}
                stroke="white"
                strokeOpacity={0.6}
                strokeWidth={1.5}
              />
              <ReferenceLine
                y={0}
                stroke="hsl(220, 15%, 75%)"
                strokeWidth={1}
                strokeDasharray="2 2"
              />
              <Tooltip
                content={({ active, payload }) => {
                  if (!active || !payload?.length) return null;
                  const { name, value } = payload[0].payload;
                  return (
                    <div className="monthly-trends__tooltip">
                      <div className="monthly-trends__tooltip-row">
                        <span className="monthly-trends__tooltip-label">
                          Month
                        </span>
                        <span className="monthly-trends__tooltip-value">
                          {name}
                        </span>
                      </div>
                      <div className="monthly-trends__tooltip-row">
                        <span className="monthly-trends__tooltip-label">
                          Value
                        </span>
                        <span className="monthly-trends__tooltip-value">
                          {value}
                        </span>
                      </div>
                    </div>
                  );
                }}
                cursor={{ fill: "rgba(0,0,0,0.04)" }}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke="#133F7D"
                // strokeWidth={2}
                fill="url(#trendGradient)"
                fillOpacity={1}
              />
              {chartData
                .filter(
                  (point) => typeof point.value === "number" && point.value > 0,
                )
                .map((point) => (
                  <ReferenceLine
                    key={point.name}
                    x={point.name}
                    stroke="rgba(255, 255, 255, 0.95)"
                    strokeDasharray="4 4"
                    strokeWidth={2}
                  />
                ))}
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default MonthlyTrends;
